<div *ngIf="!configMode" class="non-config-mode-container">
    <div class="non-config-mode-container">
        <p *ngIf="eventNotAvailable" class="event-name the-event-is-no-longer-available">
            <span translate>THE_EVENT_IS_NO_LONGER_AVAILABLE</span>
        </p>
        <div *ngIf="responseData" class="aza-pa-flex-column">
            <h4 class="waitinglist-name">{{responseData.name}}</h4>
            <div class="grid-label-value">
                <span translate>EVENT_PARTICIPANT_CAPACITY</span>
                <span>{{responseData.total}}</span>
                <span translate>REGISTERED_PARTICIPANTS</span>
                <span>{{responseData.registered}}</span>
                <ng-container *ngIf="responseData.use_waiting_list">
                    <span translate>PARTICIPANTS_IN_THE_WAITINGLIST</span>
                    <span>{{responseData.waitinglist}}</span>
                    <span translate>LIVE_REGISTRATION_SESSIONS_WITH_A_RESERVED_SPOT</span>
                    <span>{{responseData.sessions_in_use}}</span>
                    <span translate>FREE_PARTICIPANT_SPOTS_FOR_NEW_REGISTRATIONS</span>
                    <span>{{responseData.free_in_seconds}}</span>
                </ng-container>
                <ng-container *ngIf="!responseData.use_waiting_list">
                    <span translate>NO_WAITING_LIST</span>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<div *ngIf="configMode" class="config-mode-container">
    <div class="settings-container aza-pa-flex-column">
        <div class="setting-item workflow-selection">
            <azavista-input-field *ngIf="fieldsData?.workflow" [field]="fieldsData.workflow.field" [value]="fieldsData.workflow.value"
                [editMode]="true" (valueChanged)="onWorkflowChanged($event)" [label]="'WORKFLOW' | translate">
            </azavista-input-field>
        </div>
        <div class="setting-item event-selection">
            <div class="aza-pa-flex-row">
                <div *ngIf="event" class="aza-pa-flex-row">
                    <span translate>EVENT</span>:
                    <span>{{event.name}}</span>
                </div>
                <azavista-button *ngIf="!isEventPredefined" (click)="onSelectEvent()">
                    <span translate>SELECT_EVENT</span>
                </azavista-button>
            </div>
        </div>
        <!-- <div>
            <span translate>SHOW_FREE_SLOTS_WHICH_WILL_BECOME_AVAILABLE_IN</span><span> :</span>
            <azavista-duration [seconds]="definitionSettings.remote.sessions_free_in"
                (valueChanged)="onFreeslotsValueChanged($event)">
            </azavista-duration>
        </div> -->
    </div>
</div>
